import { NoticeModal, Stack, Text } from '@pairy/pds-react';

import { SetState } from '@/types/helper';
import { getUTCDate } from '@/utils/getUTCDate';
import { addJosa } from '@/utils/josa';
import { Z_INDEX } from '@/constants/zIndex';

// Plan을 downgrade할 때에 사용되는 Modal

interface Props {
  isOpen: boolean;
  setIsOpen: SetState<boolean>;
  handleConfirmButtonClick: () => void;
  expiredAt: string;
  nextPlan: string;
  originPlan: string;
}
const DowngradeModal = ({
  isOpen,
  setIsOpen,
  expiredAt,
  nextPlan,
  originPlan,
  handleConfirmButtonClick,
}: Props) => {
  return (
    <NoticeModal
      title="플랜 변경 완료"
      isOpen={isOpen}
      onOpenChange={(open: boolean) => setIsOpen(open)}
      buttonType="success"
      buttonText="확인했습니다"
      handleButtonClick={handleConfirmButtonClick}
      zIndex={Z_INDEX.rootModal}
    >
      <Stack gap={16} direction="column">
        <Text variant="xl-medium" textAlign="center">
          {getUTCDate(expiredAt, 'yearMonthDay3')}부터 <br />
          <b>{nextPlan}으로 구독 중인 Plan이 변경됩니다</b>
        </Text>
        <Text variant="md-medium" color="zinc_500" textAlign="center">
          구독 중이신 {addJosa(originPlan, '은')}
          <br />
          <b>
            {getUTCDate(expiredAt, 'yearMonthDay3')} 전까지 이용하실 수
            있습니다.
          </b>
        </Text>
      </Stack>
    </NoticeModal>
  );
};

export default DowngradeModal;
